"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticFilesMiddlewareRoute_AdminManagableAssets = exports.StaticFilesMiddlewareRoute = void 0;
exports.StaticFilesMiddlewareRoute = `api/open-storage`;
exports.StaticFilesMiddlewareRoute_AdminManagableAssets = `api/open-storage-admin`;
